import ImpersonationRequestPage from './impersonation-request-container'

export default ImpersonationRequestPage
